<template>
  <div class="order_box">
    <div :class="[isCollapse ? 'open_cop' : 'close_cop']">
      <statusbar
        ref="status_bar"
        :isTreeBar="'order'"
        @change="serch_data($event)"
        @width_change="get_width($event)"
        @getOrder="orderList($event)"
        :page_order_data="page_order_data"
      ></statusbar>
    </div>
    <div
      class="order_content"
      v-loading="page_order_data.loading_show"
      element-loading-text="拼命加载中"
    >
      <!-- 头部搜素 -->
      <div class="screen_box">
        <div style="width: 120px">
          <el-select v-model="page_order_data.timeValue" placeholder="请选择">
            <el-option
              v-for="items in options_time"
              :key="items.value"
              :label="items.label"
              :value="items.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="block">
          <el-date-picker
            v-model="picker_time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </div>
        <div style="margin-left: 20px">
          <el-select v-model="page_order_data.orderValue" placeholder="请选择">
            <el-option
              v-for="item in options_serch"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div style="width: 300px">
          <el-input v-model="page_order_data.keyword" placeholder="请输入内容"></el-input>
        </div>
        <div style="width:140px">
          <el-button type="primary" size="small" @click="serch_btn">搜索</el-button>
          <el-button type="success" size="small" @click="order_export">导出</el-button>
        </div>
      </div>
      <!-- 普通订单表 -->
      <ordertable
        v-if="page_order_data.order_type == 'general'"
        :order_list="order_list"
      ></ordertable>
      <!-- 定制单表 -->
      <customorder
        v-if="page_order_data.order_type == 'custom'"
        :order_list="order_list"
      ></customorder>

      <div class="page_block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page_order_data.pageNo"
          :page-size="page_order_data.pageSize"
          layout="total, prev, pager, next"
          :total="order_list.total"
        >
        </el-pagination>
      </div>
      
    </div>
  </div>
</template>
<script>
let _this;
import statusbar from "../../components/statusBar.vue";
import ordertable from "./components/orderTable.vue";
import customorder from "./components/customOrder.vue";
import {g_orderExport,cus_orderExport} from "@/request/api/order"
// import fileDownload from 'js-file-download'
export default {
  components: {
    statusbar,
    ordertable,
    customorder,
  },

  watch: {
    'page_order_data.timeValue': (e) => {
      //时间类型
      if (e != 0) {
        _this.page_order_data.orderDateType = e;
      } else {
        console.log("不按时间");
        _this.page_order_data.orderDateType = "";
      }
    },
    picker_time: () => {
      if (_this.picker_time) {
        _this.page_order_data.orderDateMin = _this.picker_time[0];
        _this.page_order_data.orderDateMax = _this.picker_time[1];
      } else {
        _this.page_order_data.orderDateMin = "";
        _this.page_order_data.orderDateMax = "";
      }
    },
    'page_order_data.keyValue': (e) => {
      console.log(e);
      console.log(_this.page_order_data)
      _this.page_order_data.keyword = e;
    },
    'page_order_data.orderValue': (e) => {
      _this.page_order_data.searchType = e;
      console.log(_this.page_order_data);
    },
  },
  data() {
    return {
      picker_time: "",
      page_order_data: {
        status: "ALL", //订单状态   ----默认全部订单----all
        pageNo: 1, //页数
        pageSize: 10,
        orderDateType: "", //订单时间类型；1 下单时间、2 发货时间、3 完成时间
        orderDateMin: "", //开始时间
        orderDateMax: "", //结束时间
        searchType: 1, //查询条件类型 1、订单号 2、买家/手机号 3、收货人/手机号/地址 4、商品名称
        keyword: "", //关键字
        order_type: "general", //定制单还是普通单 ---默认采购单
        orderValue:'订单号',
        timeValue:'不按时间',
        loading_show: false,
      },
      isCollapse: true,
      seacher_data: {},
      textarea: "",
      dialogVisible: false,
      options_serch: [
        {
          value: "1",
          label: "订单号",
        },
        {
          value: "2",
          label: "买家/手机号",
        },
        {
          value: "3",
          label: "收货人/手机号/地址",
        },
      ],
      options_time: [
        {
          value: "0",
          label: "不按时间",
        },
        {
          value: "1",
          label: "下单时间",
        },
        {
          value: "2",
          label: "发货时间",
        },
        {
          value: "3",
          label: "完成时间",
        },
      ],
      time_value: "不按时间",
      order_list: { records: [] },
    };
  },
  created() {
    _this = this;
  },
  methods: {
    order_export(){
      if(_this.page_order_data.order_type=="general"){
        g_orderExport(_this.page_order_data).then(res=>{
        console.log(res)
        window.open(res.msg)
        // fileDownload(res.msg, '订单'+'.xlsx')
      })
      }else{
        cus_orderExport(_this.page_order_data).then(res=>{
          // fileDownload(res.msg, '订单')
          window.open(res.msg)
        })
      }
      
    },
    serch_btn() {
      if (_this.page_order_data.order_type == "custom") {
        console.log("定制单的");
        console.log(_this.$refs.status_bar);
        _this.$refs.status_bar.get_order(_this.page_order_data);
      } else {
        _this.$refs.status_bar.get_order(_this.page_order_data);
        console.log("普通单");
      }
    },
    orderList(e) {
      _this.order_list = e;
      console.log("有获取到", _this.order_list);
    },
    get_width(e) {
      console.log(e);
      this.isCollapse = e;
    },
    serch_data(e) {
      console.log(e);
      console.log(this.page_order_data)
      this.picker_time = ""
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.serch_btn()
    },
    // 封装订单状态
    status_packing(data) {
      switch (data) {
        case 'WAIT_AUDIT':
          return '待审核';
        case 'WAIT_QUOTE':
          return '待报价';
        case 'WAITING':
          return '等待结果';
        case 'OUT':
          return '未中标';
        case 'WAIT_PAY':
          return '待支付';
        case 'WAIT_PAY_CONFIRM':
          return '支付待确认';
        case 'WAIT_SEND_GOODS':
          return '待发货';
        case 'PART_SEND_GOODS':
          return '部分发货';
        case 'WAIT_CONFIRM_SIGNED':
          return '待签收';
        case 'FINISH':
          return '完成';
        case 'CLOSED':
          return '关闭';
        case 'CANCEL':
          return '取消';
        case 'WAIT_SEND_ORDER':
          return '待派单';
        case 'WAIT_ORDER_RECEIVING':
          return '待接单';
        default:
          return '未知订单'; // 如果没有与表达式相同的值，则执行该代码
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.close_cop {
  text-align: center;
  border-right: 1px solid #eeeeee;
  -webkit-animation: width_close 1s ease forwards;
  -o-animation: width_close 1s ease forwards;
  -moz-animation: width_close 1s ease forwards;
  animation: width_close 1s ease forwards;
}
.open_cop {
  text-align: center;
  border-right: 1px solid #eeeeee;
  -webkit-animation: width_open 1s ease forwards;
  -o-animation: width_open 1s ease forwards;
  -moz-animation: width_open 1s ease forwards;
  animation: width_open 1s ease forwards;
}
@keyframes width_close {
  from {
    width: 10%;
  }
  to {
    width: 2%;
  }
}
@keyframes width_open {
  from {
    width: 2%;
  }
  to {
    width: 10%;
  }
}

.order_box {
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #fff;
  border-top: 1px solid #eeeeee;
  .order_content {
    width: 100%;
    box-sizing: border-box;
    height: 100%;
    padding: 0 10px 0 20px;
    .screen_box {
      display: flex;
      align-items: center;
      height: 10%;
      
    }

    .page_block {
      height: 5%;
      text-align: center;
    }
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 10%;
  min-height: 100%;
}
</style>